import Hero from "@/components/Hero";
import TodaysElement from "@/components/TodaysElement";
import ConditionsTeaser from "@/components/ConditionsTeaser";
import Services from "@/components/Services";
import Approach from "@/components/Approach";
import About from "@/components/About";
import Testimonials from "@/components/Testimonials";
import Events from "@/components/Events";
import Journal from "@/components/Journal";
import RoomRental from "@/components/RoomRental";
import FunFacts from "@/components/FunFacts";
import FreeGuide from "@/components/FreeGuide";
import ContactNewsletter from "@/components/ContactNewsletter";
import Community from "@/components/Community";
import FAQ from "@/components/FAQ";
import WellnessPopUp from "@/components/WellnessPopUp";

export default function Home() {
  return (
    <main data-testid="home-page">
      <Hero />
      <TodaysElement />
      <ConditionsTeaser />
      <Services />
      <Approach />
      <About />
      <Community />
      <Testimonials />
      <FreeGuide />
      <FAQ />
      <Journal />
      <WellnessPopUp />
      <FunFacts />
      <Events />
      <RoomRental />
      <ContactNewsletter />
    </main>
  );
}
